import React from 'react';
import NavLinkButton from 'common/components/NavLinkButton';
import { Outlet } from 'react-router-dom';
import './index.css';

export default function CollaborationsOutlet() {
  return (
        <section className='collaborations-section'>
            <h2 className='new-h2 add-user-title'>Колаборації</h2>
            <div className='add-user-nav-line'>
                <div className='add-user-nav-wrapper'>
                    <NavLinkButton to={'chat'}>Чат</NavLinkButton>
                    <NavLinkButton to={'mail'}>Пошта</NavLinkButton>
                    <NavLinkButton to={'calendar'}>Календар</NavLinkButton>
                    <NavLinkButton to={'planner'}>Планер</NavLinkButton>
                    <NavLinkButton to={'notes'}>Нотатки</NavLinkButton>
                    <NavLinkButton to={'reminders'}>Нагадування</NavLinkButton>
                </div>
            </div>
            <Outlet />
        </section>
  );
}